import { Route } from '@angular/router';

import { LauncherComponent } from './common/external/launcher/launcher.component';

export const appRoutes: Route[] = [{ path: '**', component: LauncherComponent }];
